module.exports = __webpack_public_path__ + "static/illustration-d4e4b95cea8e528b76bd903adf2aaf59.svg";